export default __webpack_public_path__ + "static/media/prove.3c96e838.png";